import { Mutex } from 'async-mutex';

export const searchMutex = new Mutex();
